import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { resolveSupabasePublicResource } from '../../features/runtime/supabaseAdapter';
import type { PublicResourceResolutionV1 } from '../../features/qr/types';

export function PublicResourceResolverPage() {
  const { shortCode = '' } = useParams();
  const [data, setData] = useState<PublicResourceResolutionV1 | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setData(null); setError(null);
    void resolveSupabasePublicResource(shortCode)
      .then((result) => { if (!cancelled) setData(result); })
      .catch((cause) => { if (!cancelled) setError(cause instanceof Error ? cause.message : 'Resource tidak dapat dibuka.'); });
    return () => { cancelled = true; };
  }, [shortCode]);

  return (
    <main className="resolver-shell">
      <section className="card resolver-card">
        <div className="eyebrow">BelajarKu Resource</div>
        <h1>Resource pembelajaran</h1>
        {!data && !error && <p className="muted">Memeriksa kode <strong>{shortCode}</strong>…</p>}
        {error && <div className="feedback feedback--error"><strong>Resource belum dapat dibuka.</strong><p>{error}</p></div>}
        {data && (
          <div className="stack">
            <div className="resource-summary">
              <span className="pill">{data.purpose}</span>
              <span className="muted">Mode {data.resolutionMode}</span>
            </div>
            {data.target.type === 'external' && /^https?:\/\//i.test(data.target.url) && (
              <a className="btn btn--primary" href={data.target.url} rel="noreferrer">Buka resource</a>
            )}
            {data.target.type === 'media_asset' && (
              <div className="card resource-target">
                <strong>{data.target.assetType}</strong>
                <span>{data.target.altText || 'Media pembelajaran BelajarKu'}</span>
                <span className="muted">Versi {data.target.versionNumber} · {data.target.mimeType || 'media'}</span>
                <p className="muted">Player media akan menggunakan provider/object storage pada milestone multimedia. Resolver QR-nya sudah stabil.</p>
              </div>
            )}
            {data.target.type === 'learning_object_version' && (
              <div className="card resource-target"><strong>Learning Object</strong><span>Versi {data.target.versionNumber}</span></div>
            )}
            {data.target.type === 'worksheet_version' && (
              <div className="card resource-target"><strong>Worksheet Resource</strong><span>Versi {data.target.versionNumber}</span></div>
            )}
          </div>
        )}
        <Link className="btn" to="/">Kembali ke BelajarKu</Link>
      </section>
    </main>
  );
}
